<template>
  <div class="azure-mailbox-configuration-component" v-if="shouldDisplay">
    <a-switch v-model="mailbox.is_active" v-bind:disabled="!hasEmailFolders" @change="onChange"/>
    <span style="display: inline-block; margin-left: 1.5rem; font-weight: bold; width: calc(100% - 80px);">
      {{ mailbox.name }}
      <span style="float:right; font-weight: 500;">{{ mailbox.identifier }}</span>
    </span>
    <div v-if="!hasEmailFolders">
      Voor dit account is e-mail niet ingeschakeld. Is dit niet correct, laadt de gegevens dan opnieuw in.
    </div>
    <div v-if="mailbox.is_active" style="padding: 1rem;">
      <a-form-item label="Selecteer gebruikers die eigenaar zijn van deze account">
        <users-select :value="mailbox.owner_ids" :multiple="true" @change="onOwnersChange"/>
      </a-form-item>

      <a-form-item label="Selecteer gebruikers die lees toegang hebben tot deze account">
        <users-select :value="mailbox.reader_ids" :multiple="true" @change="onReadersChange"/>
      </a-form-item>

      <a-form-item v-if="false" label="Selecteer gebruikers die verzend toegang hebben tot deze account">
        <users-select :value="mailbox.sender_ids" :multiple="true" @change="onSendersChange"/>
      </a-form-item>

      <a-form-item label="Selecteer e-mailfolders vanuit waar mail wordt geïmporteerd">
        <a-select v-model="mailbox.import_folders" mode="multiple" @change="onChange"
                  style="max-width:100%;width: 500px;">
          <a-select-option v-for="emailFolder in emailFolders" v-bind:key="emailFolder.id">
            {{ emailFolder.display_name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-switch v-model="mailbox.is_matching_enabled" @change="onChange"/>
        E-mail automatisch aan klanten koppelen
      </a-form-item>

      <a-form-item>
        <a-switch v-model="mailbox.is_processing_enabled" @change="onChange"/>
        Geïmporteerde e-mail verplaatsen
      </a-form-item>

      <a-form-item label="Selecteer de e-mailfolder waar geïmporteerde e-mails naar moeten worden verplaatst"
                   v-if="mailbox.is_processing_enabled">
        <a-select v-model="mailbox.auto_process_mailfolder_id" @change="onChange"
                  style="max-width:100%;width: 500px;">
          <a-select-option v-for="emailFolder in emailFolders" v-bind:key="emailFolder.id"
                           v-bind:value="emailFolder.id">
            {{ emailFolder.display_name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-switch v-model="mailbox.should_process_matched" @change="onChange"/>
        Gekoppelde e-mails automatisch verwerken
      </a-form-item>

      <a-form-item>
        <a-switch v-model="mailbox.should_process_unmatched" @change="onChange"/>
        Niet gekoppelde e-mails automatisch verwerken
      </a-form-item>

      <a-form-item label="Selecteer bijbehorend uitgaand email account">
        <email-accounts-select :multiple="false" v-bind:value="mailbox.email_account_id" :canDeselect="true"
                               @change="onEmailAccountChange"/>
      </a-form-item>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '../store'
import mailApi from '~/api/mailify'

export default {
  name: 'AzureMailboxConfigurationPageComponent',
  props: {
    mailbox: {
      type: Object,
      required: true
    },
    displayOverride: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      enabledFolders: [],
    }
  },
  computed: {
    ...mapGetters({
      users: '$_mailify/users',
    }),
    shouldDisplay() {
      return this.hasEmailFolders || (!this.hasEmailFolders && this.displayOverride)
    },
    hasEmailFolders() {
      return this.mailbox.folders.length > 0
    },
    emailFolders() {
      return this.mailbox.folders
    }
  },
  created() {
    const STORE_KEY = '$_mailify'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }

    this.enabledFolders = this.mailbox.folders.filter(folder => !folder.is_hidden).map(folder => folder.id)
  },
  methods: {
    onChange() {
      mailApi.updateMailbox(this.mailbox)
    },
    onOwnersChange(value) {
      Object.assign(this.mailbox.owner_ids, value);
      this.onChange()
    },
    onReadersChange(value) {
      Object.assign(this.mailbox.reader_ids, value);
      this.onChange()
    },
    onSendersChange(value) {
      Object.assign(this.mailbox.sender_ids, value);
      this.onChange()
    },
    onEmailAccountChange(value) {
      this.mailbox.email_account_id = value;
      this.onChange()
    }
  }
}
</script>

<style scoped>
.azure-mailbox-configuration-component {
  border: solid 1px #ccc;
  border-radius: 5px;
  padding: 1.5rem;
  margin: 1rem 0;
  background-color: white;
}
</style>